import React, {Component} from "react";
import DeviceTypeIcon from "../../../../../components/DeviceTypeIcon";
import DeviceRestartButton from "../../../../../components/DeviceRestartButton";

class MobilePcListItemView extends Component {
    render() {
        const {  item } = this.props;
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-2 d-flex align-items-center justify-content-center">
                        <DeviceTypeIcon customClass={item.isOnline ? "status-online" : "status-offline"} type={item.deviceType.label } />
                    </div>
                    <div className="col-5">
                        <small><b>{item.label}</b></small>
                        <p><small>{item.description}</small></p>
                    </div>

                    <div className="col-5">
                        <div style={{ textAlign: "right" }}>
                            <DeviceRestartButton deviceName={item.label} id={item.id} />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default MobilePcListItemView;
